export * from './PermissionsPromptHexagonStroke';
